import { DocumentConfigType } from '../models/documents.model';
import { DocumentRow } from '../models/integration.model';

export const documentConfigs: DocumentConfigType[] = [
  {
    title: 'Service Level Agreement',
    type: 'SLA',
    route: '/document/sla-data-input',
    timeline: [
      { label: 'Proceed your SLA data', key: 'Init' },
      { label: 'Download your SLA request', state: 2 },
      { label: 'Sending SLA request', state: 3 },
      { label: 'SLA approved', state: 5, declineLabel: 'SLA decline' },
    ],
  },
  {
    title: 'Collaboration Agreement',
    type: 'CA',
    route: '/document/ca-data-input',
    timeline: [
      { label: 'Proceed your CA data', key: 'Init' },
      { label: 'Download your CA request', state: 2 },
      { label: 'Sending CA request', state: 3 },
      { label: 'CA approved', state: 5, declineLabel: 'CA decline' },
    ],
  },
  {
    title: 'User Acceptance Test',
    type: 'UAT',
    route: '/document/uat-data-input',
    timeline: [
      { label: 'Proceed your UAT data', key: 'Init' },
      { label: 'Sending UAT request', state: 2 },
      { label: 'UAT approved', state: 5, declineLabel: 'UAT decline' },
    ],
  },
];

export const documentsQrisly: DocumentRow[] = [
  {
    id: 1,
    title: 'Service Agreement signed by the client',
    isRequired: true,
    key: 'sla_file',
  },
  {
    id: 2,
    title:
      'Business Entity Bank Account Number / Copy of Bank Account Statement',
    isRequired: true,
    key: 'bank_account_number_file',
  },
  {
    id: 3,
    title:
      'ID card (KTP) of the Director / Representative in charge of signing',
    isRequired: true,
    key: 'id_card_file',
  },
];

export const documentStatusMap: { [key: number]: string } = {
  1: 'Not Activated',
  2: 'On Process',
  3: 'On Process',
  4: 'On Process',
  5: 'Active',
  6: 'Request Decline',
};

export const documentDotStatusMap: { [key: number]: string } = {
  1: 'dot-notactived',
  2: 'dot-proceed',
  3: 'dot-proceed',
  4: 'dot-proceed',
  5: 'dot-actived',
  6: 'dot-reject',
};
